export { default } from './IssuesTable';
